"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VDateRangePicker = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var datetime_1 = require("@blueprintjs/datetime");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var moment_1 = __importDefault(require("moment"));
require("moment/locale/en-gb");
require("moment/locale/es");
require("moment/locale/fr");
var moment_2 = __importDefault(require("react-day-picker/moment"));
var Validators_1 = require("../Validators");
var FormFieldContainer_1 = require("./FormFieldContainer");
var style_1 = require("./style");
var momentFormatter = function (format) {
    return {
        formatDate: function (date) { return (0, moment_1.default)(date).format(format); },
        parseDate: function (str, locale) {
            return (0, moment_1.default)(str, format)
                .locale(locale)
                .toDate();
        },
        placeholder: "".concat(format)
    };
};
var getTimePrecision = function (precision, useAmPm) {
    if (precision) {
        return {
            timePrecision: { precision: precision },
            timePickerProps: {
                useAmPm: useAmPm !== null && useAmPm !== void 0 ? useAmPm : undefined
            }
        };
    }
};
exports.VDateRangePicker = (0, mobx_react_1.observer)(function (props) {
    var _a = (0, react_1.useState)([null, null]), date = _a[0], setDate = _a[1];
    (0, react_1.useEffect)(function () {
        if (props.value) {
            setDate(props.value);
        }
    }, [props.value]);
    var changedDate = function (dates) {
        var _a, _b, _c, _d;
        if ((dates === null || dates === void 0 ? void 0 : dates.length) === 2) {
            var newDates = [
                ((0, lodash_1.isDate)(dates[0]) && dates[0]) || null,
                ((0, lodash_1.isDate)(dates[1]) && dates[1]) || null
            ];
            if (props.fieldState) {
                (_b = (_a = props.fieldState).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, newDates);
                (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, props.fieldState.value);
                return;
            }
            setDate(newDates);
            if ((newDates[0] && newDates[1]) || (!newDates[0] && !newDates[1])) {
                (_d = props.onChange) === null || _d === void 0 ? void 0 : _d.call(props, newDates);
            }
        }
    };
    var label = props.label, labelInfo = props.labelInfo, fieldState = props.fieldState, disabled = props.disabled, inline = props.inline, id = props.id, className = props.className, layer = props.layer, fill = props.fill, margin = props.margin, value = props.value, noLabel = props.noLabel, required = props.required, popoverProps = props.popoverProps, dayPickerProps = props.dayPickerProps, maxTime = props.maxTime, minTime = props.minTime, validators = props.validators, displayRequired = props.displayRequired, tooltip = props.tooltip, allowSingleDayRange = props.allowSingleDayRange, contiguousCalendarMonths = props.contiguousCalendarMonths, tipLabel = props.tipLabel, precision = props.precision, useAmPm = props.useAmPm, onBlurStart = props.onBlurStart, onFocusStart = props.onFocusStart, onBlurEnd = props.onBlurEnd, onFocusEnd = props.onFocusEnd, _b = props.locale, locale = _b === void 0 ? 'en' : _b;
    if (fieldState) {
        if (required) {
            if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.requiredDateRange], validators, false));
            }
            else {
                fieldState.validators(Validators_1.Validators.requiredDateRange);
            }
        }
        else if (validators && validators.length > 0) {
            fieldState.validators.apply(fieldState, validators);
        }
    }
    var getValueField = function () {
        var _a;
        var dateNew = ((_a = props.fieldState) === null || _a === void 0 ? void 0 : _a.value) || date;
        try {
            if (!props.fieldState && (date === null || date === void 0 ? void 0 : date.length) === 2) {
                dateNew[0] = (0, lodash_1.isDate)(date[0]) ? new Date(date[0]) : null;
                dateNew[1] = (0, lodash_1.isDate)(date[1]) ? new Date(date[1]) : null;
            }
        }
        catch (e) {
            dateNew[0] = null;
            dateNew[1] = null;
        }
        return dateNew;
    };
    return (react_1.default.createElement(style_1.StyledDateRange, { className: className, disabled: disabled, inline: inline, intent: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.hasError) ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, margin: margin, noLabel: noLabel },
        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, value: value, tooltip: tooltip },
            tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
            react_1.default.createElement(datetime_1.DateRangeInput, __assign({}, momentFormatter(props.format || 'MM/DD/YYYY'), { locale: locale }, { disabled: disabled, minDate: minTime, maxDate: maxTime, onChange: changedDate, value: getValueField(), popoverProps: __assign({ minimal: true, shouldReturnFocusOnClose: false }, popoverProps), dayPickerProps: __assign({ fixedWeeks: true }, dayPickerProps), shortcuts: props.shortcuts, localeUtils: moment_2.default, allowSingleDayRange: allowSingleDayRange, contiguousCalendarMonths: contiguousCalendarMonths, startInputProps: {
                    onBlur: onBlurStart,
                    onFocus: onFocusStart
                }, endInputProps: {
                    onBlur: onBlurEnd,
                    onFocus: onFocusEnd
                } }, getTimePrecision(precision, useAmPm))))));
});
